/**
 * Component Registry for Hunters Oak Apartments
 * 
 * Inherits from @vibesites-dietz-property-group/theme-prestige and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-dietz-property-group/theme-prestige/registry';
import { ApartmentSyncSection } from './components/ApartmentSyncSection';
import { Header } from './components/Header';
import { Footer } from './components/Footer';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Floorplans fallback grid with the floorplan card images hidden.
  ApartmentSyncSection,
  // Header/Footer forked from the parent theme to enlarge the community logo
  // (sidebar, mobile top-bar, and footer) via className tweaks.
  Header,
  Footer,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
